import { createFetchAction } from '../helpers/fetch';
import { getToken, logout, buildTenantApiUri, constructIntlErrorMessage, displayGremlinsToaster } from '../../helpers';

// Actions
export const GET_TENANT_ESIGNATURE_DATA = 'GET_TENANT_ESIGNATURE_DATA';

// Action Creators
export function getTenantEsignatureData(formatMessage) {
  const token = getToken();
  const url = `${buildTenantApiUri(token)}/esignatures`;
  const pageFilter = /^.*\/companylist.aspx(?:\?[^?]*$)?$/i;
  return createFetchAction(GET_TENANT_ESIGNATURE_DATA, {
    url,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }, 'GETTING_TENANT_ESIGNATURE_DATA', {
    fallbackAction: logout,
    errorCodes: [401],
    failureMessage: formatMessage ? {
      exclusions: [pageFilter],
      exclusionAction: () => {
        // trigger toaster in AHR
        const messageIds = ['THERE_WAS_A_PROBLEM', 'GETTING_TENANT_ESIGNATURE_DATA', 'PLEASE_TRY_AGAIN'];
        const errorMessage = constructIntlErrorMessage(formatMessage, messageIds, '{0} {1}. {2}');
        displayGremlinsToaster(errorMessage, 'danger', 3000);
      },
    }
      : {},
  });
}

const INITIAL_STATE = {
  pricingData: {},
  isDirectClient: false,
};

export function tenants(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_TENANT_ESIGNATURE_DATA: {
      const { payload } = action;
      // const { results } = state;
      return {
        ...payload,
      };
    }
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/tenants/tenants.js